import * as IF from "infrontjs";
import template from './template.html';

import "./../main-navigation";
import "./../header-bar";
import "./../content-header";

class AppLayout extends HTMLElement
{
    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.app = IF.App.get();
            this.render();

            this._isConnected = true;
        }
    }

    render()
    {
        console.log( "Rendering..." );
        this.app.view.render(
            this,
            template,
            {
                user: this.app.user
            }
        );
    }
}

customElements.define( 'app-layout', AppLayout );
